import HttpStatusError from "./http-status-error";
import { DeviceError } from "./device-error";

const sendDeviceCommand = async (url, commandUid, commandName, commandData) => {
  const body = JSON.stringify({ cmd: commandName, uid: commandUid, data: commandData });
  const _url = `${url}/cmd`;
  return await fetch(_url, { method: "POST", body })
    .then(res => {
      if (!res.ok) {
        throw new HttpStatusError(res.status);
      }
      return res.json();
    })
    .then(answer => {
      if (answer.status !== "ok") {
        let code = "unknown";
        if (answer.errorcode.indexOf("locking") >= 0) {
          code = "locking";
        }
        throw new DeviceError(code, answer.errorcode);
      }
      return answer;
    })
    .catch(error => {
      if (error instanceof HttpStatusError) {
        throw error;
      }
      if (error instanceof DeviceError) {
        //console.error(`[ERROR] url:${url} uid:${commandUid} body:${body} || code:${error.code} text:${error.message}`); // eslint-disable-line
        throw error;
      }
      throw new Error(`Send device command error`);
    });
};

export { sendDeviceCommand };
